import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import Flex from '@components/layout/flex';
import Avatar from '@components/basics/avatar';
import Typography from '@components/basics/typography';
import DeleteIcon from '@components/basics/icons/delete';

interface OperatorItemProps {
  className?: string;
  name: string;
  src?: string;
  labelId: string;
  userId: string;
  onRemove: (labelId: string, userId: string) => void;
}

const OperatorItem: FunctionComponent<OperatorItemProps> = ({
  className,
  name,
  src,
  labelId,
  userId,
  onRemove,
}) => {
  return (
    <Flex
      className={className || ''}
      justifyContent="flex-start"
      alignItems="center"
    >
      <Avatar className="avatar" src={src} />
      <Typography className="label" weight="700">
        {name}
      </Typography>
      <DeleteIcon
        className="delete-icon"
        onClick={() => onRemove(labelId, userId)}
      />
    </Flex>
  );
};

export default styled(OperatorItem)`
  background: ${({ theme }) => theme.colors.differentBackground};
  border-radius: 4px;
  padding: 0 10px;
  height: 48px;
  user-select: none;
  overflow: hidden;
  position: relative;

  ${({ theme }) => `@media screen and ${theme.device.laptopL}`} {
    height: 60px;
    padding: 0 20px;
  }

  .avatar {
    width: 32px;
    height: 32px;
    margin-right: 10px;
  }

  .label {
    color: ${({ theme }) => theme.colors.tertiary};
  }

  .delete-icon {
    position: absolute;
    right: 10px;
    z-index: 1;

    ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
      opacity: 0;
      pointer-events: none;
      transition: opacity
        ${({ theme }) =>
          `${theme.transitions.duration} ${theme.transitions.type}`};
    }
  }

  ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
    &:hover {
      .delete-icon {
        opacity: 1;
        pointer-events: all;
      }
    }
  }
`;
